import React from "react";
import { CornerUpLeft } from "lucide-react";
import { useNavigate } from "react-router";
import { FolderItem } from "@/types/fse";

interface HomeRowProps {
  parentFolder: FolderItem | null;
}

const HomeRow: React.FC<HomeRowProps> = ({ parentFolder }) => {
  const navigate = useNavigate();

  if (!parentFolder || !parentFolder.id) {
    return null;
  }

  const handleNavigation = () => {
    navigate(parentFolder.id === "root" ? "/drive" : `/drive/${parentFolder.id}`);
  };

  return (
    <div className="flex cursor-pointer items-center p-4 py-6 hover:bg-gray-100" onClick={handleNavigation}>
      <CornerUpLeft className="mr-2 h-5 w-5 text-gray-500" />
      <span className="font-medium text-gray-500">{parentFolder.name}</span>
    </div>
  );
};

export default HomeRow;
